const chargePercentage = (state, getters, rootState, rootGetters) =>
    rootGetters['AuthModule/isCallCenter'] ||
    rootGetters['AuthModule/isGroundSeller']
        ? state.customerData.sl_customer_presets_charge
            ? state.customerData.sl_customer_presets_charge.charge_percentage
            : 0
        : 0

const discountPercentage = state =>
    state.customerData ? state.customerData.discount || null : null

/*
const assignedGroundSeller = state =>
    state.customerData && state.customerData.sl_ground_seller
        ? state.customerData.sl_ground_seller[0]
            ? state.customerData.sl_ground_seller[0]
            : state.customerData.sl_ground_seller
        : null
        */

const assignedGroundSeller = (state, getters) => {
    if (!getters.activeCustomerOffice) return null
    if (getters.activeCustomerOffice.sl_customer_ground_seller)
        return getters.activeCustomerOffice.sl_customer_ground_seller
            .sl_ground_seller
    return null
}

const activeCustomerOffice = state =>
    state.customerData &&
    state.customerData.branch_offices &&
    state.customerData.branch_offices.length
        ? state.customerData.branch_offices.find(
              office => office.id === state.activeOfficeID
          )
        : null

const activeCustomerEmail = (state, getters) =>
    getters.activeCustomerOffice ? getters.activeCustomerOffice.email : null

const activeCustomerCredit = (state, { activeCustomerOffice }) =>
    activeCustomerOffice && activeCustomerOffice.max_customer_credit
        ? {
              max_customer_credit: activeCustomerOffice.max_customer_credit,
              used_customer_credit: activeCustomerOffice.used_customer_credit,
              available_customer_credit:
                  activeCustomerOffice.max_customer_credit -
                  activeCustomerOffice.used_customer_credit,
              slack_customer_credit: activeCustomerOffice.slack_customer_credit,
              slack_customer_credit_amount: activeCustomerOffice.slack_customer_credit
                  ? Math.round(
                        (activeCustomerOffice.max_customer_credit *
                            activeCustomerOffice.slack_customer_credit) /
                            100
                    )
                  : 0,
              max_available_credit:
                  activeCustomerOffice.max_customer_credit -
                  activeCustomerOffice.used_customer_credit +
                  (activeCustomerOffice.slack_customer_credit
                      ? Math.round(
                            (activeCustomerOffice.max_customer_credit *
                                activeCustomerOffice.slack_customer_credit) /
                                100
                        )
                      : 0),
          }
        : null
const pchPaymentCondition = state =>
    state.customerData ? state.customerData.pch_payment_condition_id : null

export default {
    chargePercentage,
    assignedGroundSeller,
    activeCustomerOffice,
    activeCustomerEmail,
    discountPercentage,
    activeCustomerCredit,
    pchPaymentCondition,
}
